module.exports = __webpack_public_path__ + "static/media/footerlogo.9c0ca9ba.svg";